<template>
    <v-col cols="12" class="SystemReports mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >

                <v-card
                        class="pa-4 elevation-0 hero-reports"
                        height="100%"
                >
                    <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Portal de Reportes</h2>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                    </v-row>
                    <v-carousel 
                        class="hero-carousel"
                        height="700"
                        ref="carouselHero" 
                        hide-delimiters>
                        <v-carousel-item
                        src="@/assets/images/reports/hero/hero-reports-2.jpg"
                        >
                            <v-row
                                class="fill-height"
                                align="start"
                                justify="center"
                            >
                                <v-col class="pa-12 mt-12">
                                    <h1>
                                        Análisis de Desempeño de Plantas 1
                                    </h1>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br> 
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,<br> 
                                    when an unknown printer took a galley <br>
                                    of type and scrambled it to make a type specimen book. </p>
                                    <v-btn
                                        class="btn-report-1 mb-10"
                                        @click="dialog.detail = true"
                                    >
                                        Cómo Funciona
                                    </v-btn>
                                </v-col>
                               
                            </v-row>
                           
                        </v-carousel-item>
                         <v-carousel-item
                            src="@/assets/images/reports/hero/hero-reports-3.jpg"
                            >
                            <v-row
                                class="fill-height"
                                align="start"
                                justify="center"
                            >
                                <v-col class="pa-12 mt-12">
                                    <h1>
                                        Análisis de Desempeño de Plantas 2
                                    </h1>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br> 
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,<br> 
                                    when an unknown printer took a galley <br>
                                    of type and scrambled it to make a type specimen book. </p>
                                    <v-btn
                                        class="btn-report-1 mb-10"
                                        @click="dialog.detail = true"
                                    >
                                        Cómo Funciona
                                    </v-btn>
                                </v-col>
                               
                            </v-row>
                        </v-carousel-item>
                         <v-carousel-item
                        src="@/assets/images/reports/hero/hero-reports.jpg"
                        >
                            <v-row
                                class="fill-height"
                                align="start"
                                justify="center"
                            >
                                <v-col class="pa-12 mt-12">
                                    <h1>
                                        Análisis de Desempeño de Plantas 3
                                    </h1>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br> 
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,<br> 
                                    when an unknown printer took a galley <br>
                                    of type and scrambled it to make a type specimen book. </p>
                                    <v-btn
                                        class="btn-report-1 mb-10"
                                        @click="dialog.detail = true"
                                    >
                                        Cómo Funciona
                                    </v-btn>
                                </v-col>
                               
                            </v-row>
                        </v-carousel-item>
                    </v-carousel>
                    <v-row class="d-none d-md-flex" style="margin-top:-300px">
                                <v-card
                                        @click="$refs.carouselHero.internalLazyValue = 0"
                                        width="265"
                                        height="238"
                                        class="elevation-0 ml-8 mr-3 mt-10 text-center card-colors d-flex align-center justify-center"
                                        color="#FFAD00"
                                        dark
                                        >
                                            <div class="">
                                                <h4 >Análisis de Desempeño de<br> Plantas</h4> 
                                                <p >
                                                Lorem Ipsum is simply dummy text <br> of the printing and typesetting<br> industry. Lorem Ipsum has been the <br>industry's standard dummy.
                                                </p>
                                                <v-btn
                                                    class="btn-report-1"
                                                    @click="dialog.detail = true"
                                                    >
                                                    Cómo Funciona
                                                </v-btn>
                                            </div>
                                        
                                        </v-card>
                    
                                    <v-card
                                       @click="$refs.carouselHero.internalLazyValue = 1"
                                        width="265"
                                        height="238"
                                        class="elevation-0 mr-3 mt-10 text-center card-colors d-flex align-center justify-center"
                                        color="#FE603C"
                                        dark
                                    >
                                        <div class="">
                                            <h4 >Análisis de Desempeño de<br> Plantas</h4> 
                                            <p >
                                            Lorem Ipsum is simply dummy text <br> of the printing and typesetting<br> industry. Lorem Ipsum has been the <br>industry's standard dummy.
                                            </p>
                                            <v-btn
                                                class="btn-report-1"
                                                @click="dialog.detail = true"
                                                >
                                                Cómo Funciona
                                            </v-btn>
                                        </div>
                                    
                                    </v-card>
                            
                                    <v-card
                                        @click="$refs.carouselHero.internalLazyValue = 2"
                                        width="265"
                                        height="238"
                                        class="elevation-0 mr-3 mt-10 text-center card-colors d-flex align-center justify-center"
                                        color="#00CDCD"
                                        dark
                                    >
                                        <div class="">
                                            <h4 >Análisis de Desempeño de<br> Plantas</h4> 
                                            <p >
                                            Lorem Ipsum is simply dummy text <br> of the printing and typesetting<br> industry. Lorem Ipsum has been the <br>industry's standard dummy.
                                            </p>
                                            <v-btn
                                                class="btn-report-1"
                                                @click="dialog.detail = true"
                                                >
                                                Cómo Funciona
                                            </v-btn>
                                        </div>
                                    
                                    </v-card>
                            </v-row>
                   

                    <v-row
                        class="pa-4 pt-0"
                    >

                        <v-col class="pl-6 mb-4" cols="12" md="12" lg="9">
                            
                                <v-row class="d-none d-md-flex align-center flex-wrap">

                                    <h3 class="title-rubros align-center">Ver por rubro</h3>
                                    
                                    <v-btn class="ma-3 mx-6" icon height="60" width="60">
                                        <v-col class="justify-center d-flex flex-column">
                                            <img
                                                class="mb-3 mx-auto"
                                                width="30"
                                                src="@/assets/images/reports/ico/educacional.png"
                                                alt="educacional"
                                            >
                                            <span class="text-capitalize">Educacional</span> 
                                        </v-col>
                                       
                                    </v-btn>
                               
                                    <v-btn class="ma-3 mx-6" icon height="80" width="80">
                                        <v-col class="justify-center d-flex flex-column">
                                            <img
                                                class="mb-3 mx-auto"
                                                width="30"
                                                src="@/assets/images/reports/ico/supermercado.png"
                                                alt="supermercado"
                                            >
                                            <span class="text-capitalize">Supermercado</span> 
                                        </v-col>
                                    </v-btn>
                               
                                    <v-btn class="ma-3 mx-6" icon height="80" width="80">
                                        <v-col class="justify-center d-flex flex-column">
                                            <img
                                                class="mb-3 mx-auto"
                                                width="30"
                                                src="@/assets/images/reports/ico/edificios.png"
                                                alt="Edificios"
                                            >
                                            <span class="text-capitalize">Edificios</span> 
                                        </v-col>
                                    </v-btn>
                              
                                    <v-btn class="ma-3 mx-6" icon height="80" width="80">
                                        <v-col class="justify-center d-flex flex-column">
                                            <img
                                                class="mb-3 mx-auto"
                                                width="30"
                                                src="@/assets/images/reports/ico/mineria.png"
                                                alt="Mineria"
                                            >
                                            <span class="text-capitalize">Mineria</span> 
                                        </v-col>
                                    </v-btn>
                                </v-row>
                                    
                           
                            
                        </v-col>
                       
                        <v-col class="mb-0 d-flex justify-end" cols="12" md="12" lg="3">
                            <v-text-field
                                    placeholder="Buscar en esta tabla..."
                                    outlined
                                    dense
                                    class="buscardor-reports mt-12 pr-6"
                                    append-icon="mdi-magnify"
                            ></v-text-field>
                        </v-col>

                    
                        <v-col 
                            v-for="(categoria,icat) in ['Educacional','Supermercados','Edificios','Mineria']"
                                            :key="icat"
                                cols="12" class="px-0 pt-0">
                                <h3 class="ml-6 title-category">{{categoria}}</h3>
                                <v-slide-group show-arrows>
                                    <v-slide-item
                                        v-for="(item,i) in 12"
                                        :key="i+'-c-1'"
                                    >
                                            <v-card
                                                width="300"
                                                height="250"
                                                class="ma-4 elevation-0 text-center card-reports d-flex align-center justify-center"
                                            >
                                                <div class="">
                                                    <h4 >Análisis de Desempeño de<br> Plantas</h4> 
                                                    <p >
                                                    Lorem Ipsum is simply dummy text <br> of the printing and typesetting<br> industry. Lorem Ipsum has been the <br>industry's standard dummy.
                                                    </p>
                                                    <v-btn
                                                        class="btn-report-2"
                                                        @click="dialog.detail = true"
                                                        >
                                                        Cómo Funciona
                                                    </v-btn>
                                                </div>
                                            </v-card>
                                    </v-slide-item>
                                </v-slide-group>
                        </v-col>
                        
                    </v-row>


                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog.video"
            width="861"
            >
                <v-card class="pa-8 elevation-0"
                    tile
                >
                    <v-card-text>
                        <v-row>
                            <img
                                            src="@/assets/images/reports/video.png"
                                            alt="Video"
                                            width="100%"
                                    >

                        </v-row>
                    </v-card-text>
                </v-card>
        </v-dialog>

        <v-dialog
            
            v-model="dialog.detail"
            width="861"
            >
                <v-card class="pa-8 elevation-0 card-detail"
                    tile
                    :style="{ backgroundImage: 'url(' + require('@/assets/images/reports/hero/hero-reports-3.jpg') + ')' }"
                >
                    <v-card-title class="headline pt-0 mx-auto justify-center">

                        <v-row >
                            <v-col cols="12" lg="7">
                                <h1 class="font-weight-regular text-left font-family-1 font-size-30 mt-10 mb-4">
                                Análisis de Desempeño de Plantas
                                </h1>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                </p>
                                <h5 class="mt-12" style="color:#FFFFFF">Informe ideal para</h5>
                                <v-card class="pa-5 d-flex justify-space-around" width="350">
                                    <img
                                            src="@/assets/images/reports/ico/educacional.png"
                                            alt="educacional"
                                    >

                                    <img
                                        src="@/assets/images/reports/ico/supermercado.png"
                                        alt="supermercado"
                                >

                                    <img
                                        src="@/assets/images/reports/ico/edificios.png"
                                        alt="edificios"
                                >

                                    <img
                                        src="@/assets/images/reports/ico/mineria.png"
                                        alt="mineria"
                                >
                                </v-card>
                            </v-col>
                            <v-col cols="12" lg="5">
                                
                                <v-card class="elevation-0 card-value-dialog"
                                >
                                    <v-card-title>
                                        <h5 v-if="dialog.plan == '5'" ><span class="big"> 125 UF</span> Incluye 5 informe</h5>
                                        <h5 v-else-if="dialog.plan == '10'" ><span class="big"> 250 UF</span> Incluye 10 informe</h5>
                                        <h5 v-else-if="dialog.plan == 'ilimitado'" ><span class="big"> 500 UF</span> Incluye informes ilimitados</h5>
                                        <h5 v-else-if="dialog.plan == '1'" ><span class="big"> 25 UF</span> Incluye 1 informe</h5>
                                        <h5 v-else ><span class="big"> 25 UF</span> Incluye 1 informe</h5>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-radio-group v-model="dialog.plan" :mandatory="false">
                                            <v-radio color="white" label="Default" value="1"></v-radio>
                                            <v-radio color="white" label="Plan 5 informes" value="5"></v-radio>
                                            <v-radio color="white" label="Plan 10 informes" value="10"></v-radio>
                                            <v-radio color="white" label="Plan Acceso Ilimitado" value="ilimitado"></v-radio>
                                        </v-radio-group>
                                        <a class="ma-auto">Ver más información</a>
                                    </v-card-text>
                                </v-card>

                                <v-btn
                                class="btn-report-3 mt-3 mb-0"
                                to="/system/reports/payment"
                                    >
                                    Agregar al carro
                                </v-btn>
                                <v-btn
                                class="btn-report-4 mt-3 mb-0"
                                    >
                                    Contáctanos
                                </v-btn>
                            </v-col>
                            
                        </v-row>
                    </v-card-title>
                    <v-card-text class="card-detail-text" >
                        <v-row>
                            <v-col cols="12" lg="6">
                                <p class="text-justify">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. 
                                </p>
                                <p class="text-justify">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the.
                                </p>
                            </v-col>
                            <v-col cols="12" lg="6">
                        

                                <v-carousel height="200px" hide-delimiters>
                                            <v-carousel-item
                                            v-for="(item,i) in 5"
                                            :key="i"
                                            >
                                                <v-row>
                                                    <v-col>
                                                        <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="190px">
                                                            <h3 class="grey--text">Grafico {{1+(i)}}</h3>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-carousel-item>
                                        </v-carousel>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
        </v-dialog>
    </v-col>
</template>

<script>
    export default {
        name: 'SystemReports',
        data() {
            return {
                dialog:{
                    video:false,
                    detail:false,
                    plan:'1'
                }
            }
        },
        metaInfo: {
            title: 'Neocity - Reportes',
            meta: [
                { name: 'title',content:'Neocity - Reportes'},
                { name: 'description',content:'esta es una descripcion'},
            ],
        
        },
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>